
import { defineComponent } from 'vue';
import Dropdown3 from '@/components/dropdown/Dropdown3.vue';
import Header from '@/components/siteComponents/Header.vue';
import Footer from '@/components/siteComponents/Footer.vue';

export default defineComponent({
  name: 'profile',
  components: {
    Header,
    Footer,
    Dropdown3,
  },
});
